import type { QuoteCargoTypesListResponse } from '@/modules/spot-quote/data-provider/quote-cargo-types-list/api';

export const normalizeQuoteCargoTypesList = (data: QuoteCargoTypesListResponse): { label: string; value: string }[] => {
  if (!data) {
    return [];
  }

  return data.map((row) => ({
    label: row.codeDesc,
    value: row.codeId,
  }));
};
